module.exports = __webpack_public_path__ + "img/roles.2a8eeea7.svg";